export default {
  title: 'Feedback · {stage}',
  reportVersion: 'Versão do relatório',
  latest: 'mais recente',
  feedbackOn: 'Feedback sobre {stage}',
  hint: 'Ainda não há mensagens. Escreva seus comentários enquanto percorre o relatório; a equipe da NG os responderá aqui.',
  downloadDeliverable: 'Baixar {name}',
  you: 'Você',
  staff: 'Equipe da NG',
  onReport: 'Escrito sobre o relatório v{version} · clique para mostrá-lo',
  edit: 'Editar',
  delete: 'Excluir',
  edited: 'Editado em {date}',
  deleted: 'Mensagem excluída por {name} · {date}',
  deleteConfirm: 'Excluir esta mensagem? Todos verão que você a excluiu.',
  placeholder: 'Escreva uma mensagem…',
  sendHint: '⌘/Ctrl + Enter para enviar',
  cancel: 'Cancelar',
  send: 'Enviar',
  save: 'Salvar',
  discardConfirm: 'Descartar a mensagem não enviada?',
  errorSaving: 'Não foi possível salvar a mensagem. Tente novamente.',
  errorDeleting: 'Não foi possível excluir a mensagem. Tente novamente.',
  dividerHint: 'Arraste para redimensionar · clique para ocultar o feedback',
  showFeedback: 'Mostrar feedback',
  feedbackTab: 'Feedback'
}
